import { Observable, of } from 'rxjs'
import { filter, map, switchMap, take, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Organization } from '../organization'
import { organizationActions } from '../organization.actions'
import { organizationSelectors } from '../organization.selectors'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { NotificationService } from 'src/app/core/notification.service'
import { OrganizationService } from '../organization.service'
import { documentSelectors } from '../../document/document.selectors'
import { Dictionary } from '@ngrx/entity'
import { Document } from '../../document/document'
import { environment } from 'src/environments/environment'
import { Actions } from '@ngrx/effects'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'organization-documents-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationDocumentsTabComponent implements OnInit {
  public organization$: Observable<Organization>
  public organizationId$: Observable<number>
  public organizationId: number
  public documentEntities$: Observable<Dictionary<Document>>
  public documents$: Observable<Document[]>
  public staticAssetBaseUrl: string = environment.staticAssetBaseUrl

  public BulkAction = BulkAction

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private organizationService: OrganizationService,
    private actions$: Actions,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.organizationService.showModal) {
      this.activeRoute.params.pipe(take(1)).subscribe((params) => {
        if (params.hasOwnProperty('organizationId')) {
          this.organizationId$ = of(Number(params['organizationId']))
        }
      })
    } else {
      this.organizationId$ = this.store
        .select(organizationSelectors.selectIdRouteParam)
        .pipe(filter((id) => Boolean(id)))
    }

    this.documentEntities$ = this.store.select(documentSelectors.selectEntities)

    this.organization$ = this.organizationId$.pipe(
      tap((id) =>
        this.store.dispatch(
          organizationActions.fetchOneById({
            id,
            params: RequestQueryBuilder.create({
              join: [{ field: 'tags' }, { field: 'documents' }]
            })
          })
        )
      ),
      switchMap((organizationId) =>
        this.store.select(organizationSelectors.selectById, organizationId)
      )
    )

    this.documents$ = this.organization$.pipe(
      filter((p) => Boolean(p)),
      switchMap((organization) =>
        this.store
          .select(documentSelectors.selectAll)
          .pipe(
            map((documents) =>
              documents.filter((document) =>
                organization?.documents?.includes(document.id)
              )
            )
          )
      )
    )
  }

  public onSubmitImage(file: File) {
    this.organizationId$
      .pipe(take(1))
      .subscribe((organizationId) =>
        this.organizationService.saveOneWithFile(organizationId, file)
      )
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      this.organizationId$.pipe(take(1)).subscribe((organizationId) => {
        bulkActionEvent.items.forEach((item) =>
          this.organizationService.deleteOneWithFile(organizationId, item.id)
        )
      })
    }
  }
}
